import {
	Anchor,
	FontIconName,
	Icon,
	RadioButton
} from "client/Components";
import {
	MouseEvent,
	ReactElement,
	useCallback
} from "react";
import { useCallbackWithoutArguments } from "client/Hooks";
import classNames from "classnames";
import styles from "./SelectionCard.module.less";
import { isNotNil, setTrackingId } from "client/Misc/utils";
import { localize } from "client_legacy/ndaw/culture";

export type SelectionCardProps = {
	icon?: FontIconName;
	title: string;
	description: string;
	isSelected: boolean;
	onClick: () => void;
	onDoubleClick?: () => void;
	trackingId: string;
	onViewExamples?: () => void;
};

export const SelectionCard = (props: SelectionCardProps): ReactElement => {
	const {
		icon,
		title,
		description,
		isSelected,
		onClick: onClickFromProps,
		onDoubleClick: onDoubleClickFromProps,
		trackingId,
		onViewExamples
	} = props;

	const onClick: () => void = useCallbackWithoutArguments(onClickFromProps);
	const onDoubleClick: (() => void) | undefined = useCallbackWithoutArguments(onDoubleClickFromProps);

	const viewExamplesHandler = useCallback(
		(args: MouseEvent<HTMLAnchorElement>): void => {
			args.stopPropagation();
			onViewExamples?.();
		},
		[onViewExamples]
	);

	return (
		<div
			{...setTrackingId(trackingId)}
			className={classNames(
				styles.root,
				{
					[styles.root_selected]: isSelected
				}
			)}
			onClick={onClick}
			onDoubleClick={onDoubleClick}
		>
			<div className={styles.header}>
				{isNotNil(icon) && (
					<div className={styles.iconWrapper}>
						<Icon value={icon} />
					</div>
				)}
				<h4 className={styles.title}>
					{title}
				</h4>
				<RadioButton
					value={isSelected}
					onChange={onClick}
					trackingId="select"
				/>
			</div>
			<div className={styles.description}>{description}</div>
			{isNotNil(onViewExamples) && (
				<div className={styles.footer}>
					<Anchor
						onClick={viewExamplesHandler}
						trackingId="view-examples"
					>
						{localize("_ViewExamples")}
					</Anchor>
				</div>
			)}
		</div>
	);
};
SelectionCard.displayName = "SelectionCard";
